<template>
	<div>
		<ManagingSection class="search-by-enter__container">
			<ManagingBox title="회원 ID">
				<input
					class="search-by-enter__target"
					v-model="searchId"
					type="number"
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="getSearch()">
				검색
			</button>
			<button
				class="btn-main blue bordered"
				type="button"
				@click="initSearch"
			>
				검색조건 초기화
			</button>
		</div>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left register-block__summary">
					차단한 회원 기준 {{ totalCount }}개 검색됨, 최근 1000개
					까지의 데이터만 조회함
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th>회원</th>
						<th>차단대상</th>
						<th>차단시간</th>
						<th>관리</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in blockList" :key="item.id">
						<td>{{ item.id }}</td>
						<td>{{ item.registerId }}({{ item.nickName }})</td>
						<td>
							{{ item.targetRegisterId }}({{
								item.targetRegisterNickName
							}})
						</td>
						<td>{{ item.createdAt }}</td>
						<td>
							<button
								class="btn blue"
								@click="
									deleteRecord(
										item.id,
										item.targetRegisterNickName
									)
								"
							>
								차단해제(이력삭제)
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
		<PaginationBox
			:limit="limit"
			:offset="offset"
			:totalItem="totalCount"
			@to="onPagination($event.offset)"
			class="register-block__pagination"
		/>
	</div>
</template>
<script>
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'RegisterBlock',
		components: {
			ManagingSection,
			ManagingBox,
			SearchByEnter,
			PaginationBox,
		},
		extends: SearchByEnter,
		data() {
			return {
				searchId: '',
				offset: 0,
				limit: 10,
				blockList: [],
				totalCount: 0,
			};
		},
		created() {
			this.getList();
		},
		methods: {
			getSearch() {
				if (this.searchId.trim().length === 0) {
					alert('회원 ID를 확인해 주세요');
				} else {
					this.getList();
				}
			},
			initSearch() {
				this.searchId = '';
				this.getList();
			},
			async getList() {
				try {
					this.offset = this.searchId ? 0 : this.offset;
					const params = {
						offset: this.offset,
						limit: this.limit,
						registerId: this.searchId,
					};
					const { data } = await this.$axiosAdmin2.get(
						'/v3/api/register/block/list',
						{ params }
					);
					this.totalCount = data.totalCount;
					this.blockList = data.data;
					this.blockList.forEach(item => {
						item.createdAt = moment(item.createdAt * 1000).format(
							'YYYY-MM-DD HH:mm:ss'
						);
					});
				} catch (err) {
					console.error(err);
					alert(
						'리스트를 불러오기에 실패하였습니다. 개발팀에 문의하세요'
					);
				}
			},
			onPagination(offset) {
				this.offset = offset;
				this.getList();
			},
			async deleteRecord(id, targetName) {
				if (
					!confirm(
						`[${targetName}] 회원을 대상으로 한 차단 이력을 정말 삭제하나요?`
					)
				)
					return;
				try {
					await this.$axiosAdmin2.delete(
						`/v3/api/register/block/${id}`
					);
					alert('차단해제(이력삭제) 되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					alert('삭제에 실패하였습니다. 개발팀에 문의하세요');
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.register-block__summary {
		font-weight: bold;
	}
	.register-block__pagination {
		margin-top: 20px;
	}
</style>
